import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Link as MuiLink,
} from "@mui/material";
import WbSunnyIcon from "@mui/icons-material/WbSunny";

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#0f172a",
        py: 8,
        color: "text.secondary",
        borderTop: "1px solid rgba(255,255,255,0.05)",
      }}
    >
      <Box
        sx={{
          maxWidth: 1280,
          mx: "auto",
          px: 2,
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
          gap: 6,
        }}
      >
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
            <WbSunnyIcon sx={{ color: "primary.main" }} />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 900,
                color: "white",
                fontStyle: "italic",
                textTransform: "uppercase",
              }}
            >
              SolarFaith
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ lineHeight: 1.8, maxWidth: 280 }}>
            A nonprofit initiative dedicated to bringing light to rural
            religious centers across sub-Saharan Africa.
          </Typography>
        </Box>

        <Box>
          <Typography sx={{ color: "white", fontWeight: 700, mb: 3 }}>
            Transparency
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {["Financial Reports", "Project Audits", "Impact Data"].map(
              (label) => (
                <MuiLink
                  key={label}
                  href="#"
                  underline="none"
                  sx={{
                    color: "text.secondary",
                    fontSize: 14,
                    "&:hover": { color: "white" },
                    transition: "color 0.2s",
                  }}
                >
                  {label}
                </MuiLink>
              ),
            )}
          </Box>
        </Box>

        <Box>
          <Typography sx={{ color: "white", fontWeight: 700, mb: 3 }}>
            Stay Updated
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              placeholder="Email"
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  bgcolor: "rgba(255,255,255,0.05)",
                  borderRadius: 2,
                  color: "white",
                  "& fieldset": { borderColor: "rgba(255,255,255,0.1)" },
                  "&:hover fieldset": { borderColor: "rgba(255,255,255,0.2)" },
                  "&.Mui-focused fieldset": { borderColor: "#ea580c" },
                },
              }}
            />
            <Button
              variant="contained"
              color="primary"
              sx={{ borderRadius: 2, px: 3 }}
            >
              Join
            </Button>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          maxWidth: 1280,
          mx: "auto",
          px: 2,
          mt: 8,
          pt: 4,
          borderTop: "1px solid rgba(255,255,255,0.05)",
          textAlign: "center",
        }}
      >
        <Typography variant="caption" sx={{ color: "#475569" }}>
          © 2026 SolarFaith Initiative. All Rights Reserved. Empowered by the
          African Sun.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
